import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, Grid, makeStyles, Typography } from "@material-ui/core";
import CircularProgresss from "views/components/CircularProgress/CircularProgress";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import { useSelector } from "react-redux";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import Button from "../../components/CustomButtons/Button";
import CustomTextField from "components/UpdateUi/CustomeTextField";
import CustomSelect from "components/UpdateUi/CustomeSelect";
import ToastModal from "views/components/ToastModal";
import brandTheme from "brandTheme/Theme";
import { removeSpecialCharFileName } from "utils/Utils";
import FileUploadDocument from "views/components/FileUpload/FileUploadDocument";
import { status } from "assets/properties/properties";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import { parseDateMDY } from "utils/Utils";
import BottomButton from "components/UpdateUi/BottomButton/BottomButton";
import { toCamelCase } from "utils/Utils";

const useStyles = makeStyles((theme) => ({
  container: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    width: "92%",
    margin: "0 auto",
    // minHeight: "85vh",
    overflow: "hidden",
  },
  content: {
    flexGrow: 1, // Allows content to expand and scroll
    overflowY: "auto", // Enables scrolling inside content
    paddingBottom: theme.spacing(2), // Avoids content cutting off at bottom
  },
  footer: {
    textAlign: "end",
    padding: theme.spacing(2),
    background: "#fff",
    position: "sticky",
    bottom: 0,
  },
  inputFieldContainer: {
    margin: "0 auto 30px",
    maxWidth: "1100px",
  },
  fieldContaienr: {
    margin: "2% 2% 0px 0px",
    maxWidth: "31.3%",
    "@media (max-width: 768px)": {
      maxWidth: "46%",
      margin: "5% 2% 0px 2%",
    },
    "@media (max-width: 600px)": {
      maxWidth: "100%",
    },
    "@media (max-width: 450px)": {
      margin: "10% 2% 0px 2%",
    },
  },
  button: {
    background:
      "linear-gradient(135deg, #15254F 0%, #1CB167 50%, #28D17F 100%)",
    color: brandTheme.white,
    borderRadius: "10px",
    padding: "10px 15px",
    minWidth: "140px",
    textTransform: "capitalize",
    "&:hover": {
      background:
        "linear-gradient(135deg, #15254F 0%, #1CB167 50%, #28D17F 100%)",
    },
  },
}));

const BankAnalyser = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  // const leadDetails = location.state?.leadDetails;
  const { leadId } = useSelector((state) => state.login.userCurrentLead);
  const [bankName, setBankName] = useState("");
  const [callInProgress, setCallInProgress] = useState(false);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [disaledFields, setDisabledFields] = useState(false);
  const [pollingDone, setPollingDone] = useState(false);
  const [statementLink, setStatementLink] = useState("");
  const [password, setPassword] = useState("");
  const [bankOptions, setBankOptions] = useState([]);
  const [initiateBankApi, setInititateBankApi] = useState(false);
  const [bankErrorMessage, setBankErrorMessage] = useState("");
  const [bankDetails, setBankDetails] = useState(null);
  const breSuccess = location.state?.breSuccess || false;
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  useEffect(() => {
    if (!bankOptions?.length) {
      getBankNames();
    }
  }, [bankOptions]);
  const getBankNames = async () => {
    const result1 = await apiHandler({
      url: endpoint.BANK_ANALYZER_INSITIUTE_NAMES,
      authToken: authToken,
    });
    if (result1?.data?.error_code) {
      toastUpdate("Error", result1?.data?.user_description, true);
    } else {
      const bankOptionsList = (result1?.data?.institutionsName || []).map(
        (name) => ({
          value: name,
          label: name,
        })
      );

      setBankOptions(bankOptionsList);
      await getBankAnalysisDetails();
    }
  };
  const getBankAnalysisDetails = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.USER_BANK_ANALYSER_GET_API + leadId,
      method: "GET",
      authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      return;
    }
    if (result?.data?.status?.toLowerCase() === status.completed) {
      setBankDetails(result.data);
      if (result.data.nameMismatch) {
        toastUpdate(
          "Error",
          "Applicant name does not match the bank statement.",
          true
        );
        setDisabledFields(false);
        setPollingDone(false);
        return;
      }

      setPollingDone(true);
      setDisabledFields(true);
    }
  };
  useEffect(() => {
    let interval;

    const pollBankStatus = async () => {
      setCallInProgress(true);

      const result = await apiHandler({
        url: endpoint.USER_BANK_ANALYSER_GET_API + leadId,
        method: "GET",
        authToken,
      });

      if (result?.data?.status?.toLowerCase() === status?.completed) {
        setBankErrorMessage("");
        setBankDetails(result.data);
        if (result?.data?.nameMismatch) {
          toastUpdate(
            "Error",
            "Applicant name does not match the bank statement.",
            true
          );
        
          setDisabledFields(false);
          setPollingDone(false);
          setInititateBankApi(false);
          setCallInProgress(false);
          clearInterval(interval);
          return;
        }else {
          toastUpdate("Success", "Bank authentication successful", true);
          setPollingDone(true);
          setDisabledFields(true);
        }
        setCallInProgress(false);
        clearInterval(interval);
      } else if (
        result?.data?.status?.toLowerCase() === status?.failure ||
        result?.data?.status?.toLowerCase() === status?.error
      ) {
        setBankErrorMessage(
          result?.data?.message || "Bank authentication failed"
        );
        setCallInProgress(false);
      } else if (result?.data?.error_code) {
        toastUpdate("Error", result?.data?.user_description, true);
        setBankErrorMessage(result?.data?.user_description);
        setCallInProgress(false);
      }
    };

    if (bankName && !pollingDone && initiateBankApi) {
      pollBankStatus();
      interval = setInterval(() => {
        pollBankStatus();
      }, 30000);
    }
    return () => clearInterval(interval);
  }, [bankName, pollingDone, initiateBankApi]);

  const saveUserGeneralDetails = async () => {
    setBankErrorMessage("");
    let data = {
      leadApplicationId: leadId,
      institutionName: bankName,
      filePassword: password,
      destination: "STATEMENT_UPLOAD",
      fileUrl: statementLink,
    };

    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.USER_BANK_ANALYSER_API,
      method: "POST",
      authToken: authToken,
      data,
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      const parsed = JSON.parse(res.data.user_description);
      const message = parsed?.msg || res?.data?.user_description;
      toastUpdate("Error", message, true);
      setCallInProgress(false);
    } else {
      setInititateBankApi(true);
    }
  };

  const UploadFile = async (file) => {
    const formData = new FormData();
    const fileName = removeSpecialCharFileName(file.name);
    formData.append("file", file, fileName);
    setCallInProgress(true);
    const path = await apiHandler({
      url: endpoint.FILE_UPLOAD,
      method: "POST",
      authToken: authToken,
      data: formData,
    });
    setCallInProgress(false);
    if (!path?.data?.error_code) {
      const uploadedPath = path.data;
      setStatementLink(uploadedPath?.name);
    }
  };

  const isFormValid = () => {
    if (!bankName || !statementLink) return false;
    return true;
  };
  const handleNext = async () => {
    if (!pollingDone) {
      await saveUserGeneralDetails();
      return;
    }
    if(breSuccess) {
        navigate("/journey/SelfiePhoto");
    } else {
      setCallInProgress(true);
      try {
        const apiData = {
          // testApplicationId: leadDetails === "current" ? leadId : leadDetails,
          isBankStatementRequired: true,
        };

        const result = await apiHandler({
          url: endpoint.GET_CUSTOMER_ELIGIBILITY + leadId,
          method: "POST",
          authToken,
          data: apiData,
        });
        if (result?.data?.error_code) {
          toastUpdate("Error", result.data.user_description, true);
          return;
        }
      switch (result?.data?.decision?.trim().toLowerCase()) {
        case "reject":
        case "rejected":
          navigate("/loanRejected");
          break;
        case "approve":
        case "approved":
          navigate("/journey/SelfiePhoto");
          break;

        default:
          toastUpdate(
            "Error",
            "We couldn't process your loan decision. Please try again later.",
            true
          );
      }
      } catch (error) {
        toastUpdate(
          "Error",
          "Something went wrong. Please try again later.",
          true
        );
      } finally {
        setCallInProgress(false);
      }
    }
  };
  return (
    <Grid container className={classes.container}>
      <Grid item xs={12}>
        <SubHeader label="Income Verify" />
      </Grid>
      <Grid
        item
        xs={12}
      >
        <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
          {!pollingDone && (
            <>
              <Grid container className={classes.inputFieldContainer}>
                {bankErrorMessage && (
                  <Grid item xs={12} style={{ marginTop: 16 }}>
                    <div
                      style={{
                        color: "#d32f2f",
                        fontSize: 18,
                        fontWeight: 800,
                        textAlign: "center",
                      }}
                    >
                      {bankErrorMessage}
                    </div>
                  </Grid>
                )}
                <Grid item xs={12} sm={12} md={12}>
                  <Box
                    style={{
                      background: "#F8FFFB",
                      border: "1px solid #D8F3E4",
                      borderRadius: 12,
                      padding: 20,
                      marginBottom: 24,
                    }}
                  >
                    <Typography
                      variant="h6"
                      style={{
                        color: "#1CB167",
                        fontWeight: 700,
                        marginBottom: 12,
                      }}
                    >
                      Instructions
                    </Typography>

                    {[
                      "Upload a single PDF containing your last 3 months' bank statement.",
                      "Ensure the statement includes transactions up to today's date.",
                      "If the PDF is password-protected, enter the password below.",
                      "Make sure all pages are clear and readable.",
                    ].map((item, index) => (
                      <Box
                        key={index}
                        display="flex"
                        alignItems="flex-start"
                        mb={1.5}
                      >
                        <CheckCircleIcon
                          style={{
                            color: "#1CB167",
                            fontSize: 18,
                            marginRight: 10,
                            marginTop: 2,
                          }}
                        />
                        <Typography
                          style={{
                            fontSize: 14,
                            color: "#555",
                            lineHeight: 1.6,
                          }}
                        >
                          {item}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  className={classes.fieldContaienr}
                >
                  <CustomSelect
                    label="Bank Name"
                    value={bankName}
                    onChange={(e) => setBankName(e.target.value)}
                    options={bankOptions}
                    style={classes.documentSelectBox}
                    disabled={disaledFields}
                  />
                </Grid>
                <Grid item xs={12} sm={4} className={classes.fieldContaienr}>
                  <FileUploadDocument
                    addButtonProps={{ color: brandTheme.buttonColor }}
                    changeButtonProps={{ color: brandTheme.buttonColor }}
                    removeButtonProps={{ color: brandTheme.button2Color }}
                    supportedMimeType={[
                      "image/jpeg",
                      "image/bmp",
                      "image/png",
                      "image/tiff",
                      "application/pdf",
                    ]}
                    sendFile={(file) => UploadFile(file)}
                    removeFile={() => setStatementLink("")}
                    previewImage={statementLink}
                    removeButton={false}
                    completed={disaledFields}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={4}
                  style={{ textAlign: "right" }}
                  className={classes.fieldContaienr}
                >
                  <CustomTextField
                    label="Password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    style={classes.inputField}
                    disabled={disaledFields}
                  />
                </Grid>
              </Grid>
            </>
          )}
          {pollingDone && (
            <Box
              mt={4}
              style={{
                background: "#fff",
                border: "1px solid #E5E7EB",
                borderRadius: 20,
                overflow: "hidden",
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
              }}
            >
              {/* Header */}
              <Box
                display="flex"
                flexWrap="wrap"
                justifyContent="space-between"
                alignItems="center"
                style={{ gap: 16 }}
              >
                <Box display="flex" alignItems="center">
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    style={{
                      width: 56,
                      height: 56,
                      borderRadius: 14,
                      background: "#ECFDF3",
                      marginRight: 16,
                      flexShrink: 0,
                    }}
                  >
                    <AccountBalanceIcon
                      style={{
                        color: "#1CB167",
                        fontSize: 30,
                      }}
                    />
                  </Box>

                  <Box>
                    <Typography
                      style={{
                        fontSize: "clamp(20px, 3vw, 30px)",
                        fontWeight: 700,
                        color: "#1D2B53",
                      }}
                    >
                      Bank Analysis Details
                    </Typography>

                    <Typography
                      style={{
                        color: "#7A7A7A",
                        fontSize: 15,
                      }}
                    >
                      Verified bank statement information
                    </Typography>
                  </Box>
                </Box>

                {statementLink && (
                  <Typography
                    component="a"
                    href={statementLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: "#1976d2",
                      textDecoration: "underline",
                      fontWeight: 600,
                      cursor: "pointer",
                    }}
                  >
                    View Statement
                  </Typography>
                )}
              </Box>

              {/* Details */}
              <Box p={3}>
                <Grid container spacing={3}>
                  {[
                    {
                      label: "Bank Account No",
                      value: bankDetails.bankAccountNo,
                    },
                    {
                      label: "IFSC Code",
                      value: bankDetails.ifscCode,
                    },
                    {
                      label: "Bank Name",
                      value: toCamelCase(bankDetails.bankName),
                    },
                    {
                      label: "Branch",
                      value: toCamelCase(bankDetails.branch),
                    },
                    {
                      label: "Beneficiary Name",
                      value: toCamelCase(bankDetails.beneficiaryName),
                    },
                    {
                      label: "Account Type",
                      value: toCamelCase(bankDetails.accountType),
                    },
                    {
                      label: "Txn Start Date",
                      value: parseDateMDY(bankDetails.txnStartDate),
                    },
                    {
                      label: "Txn End Date",
                      value: parseDateMDY(bankDetails.txnEndDate),
                    },
                    {
                      label: "Last Salary Credited",
                      value: parseDateMDY(bankDetails.lastSalaryCreditedDate),
                    },
                    {
                      label: "Name Mismatch",
                      value: bankDetails.nameMismatch ? "Yes" : "No",
                    },
                  ].map((item, index) => (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                      <Typography
                        style={{
                          color: "#8A8A8A",
                          fontSize: 14,
                          marginBottom: 6,
                        }}
                      >
                        {item.label}
                      </Typography>

                      <Typography
                        style={{
                          color: "#1D2B53",
                          fontWeight: 700,
                          fontSize: 18,
                          wordBreak: "break-word",
                        }}
                      >
                        {item.value || "-"}
                      </Typography>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            </Box>
          )}
        </Grid>
      </Grid>
      <BottomButton
        button1={pollingDone ? "Next" : "Proceed"}
        button1click={handleNext}
        disabled1={!isFormValid() || callInProgress}
      />
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
    </Grid>
  );
};

export default BankAnalyser;
